<div class="card">
  <div class="card-header card-header-squirrel">
    <h4>Mandantengruppen zuweisen</h4>
  </div>
  <div class="card-body">
    <form [formGroup]="TGRForm" novalidate>
      <div class="row">
        <div class="col-md-12">
          <mat-form-field appearance="fill" >
            <mat-label>{{this.translate.data['SELECTTENANTGROUPROLE'] | translate}}</mat-label>
            <!-- <mat-label>Wählen Sie Mandantengruppenrollen aus</mat-label> -->
            <mat-select formControlName="userRoles" multiple>
              @for (role of groupRoles; track role) {
                <mat-option [value]="role">
                  {{role.name}}
                </mat-option>
              }
            </mat-select>
            @if (!TGRForm.controls['userRoles'].valid && TGRForm.controls['userRoles'].touched) {
              <mat-error> {{this.translate.data['ERRORALERT'] | translate}} </mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <a>
          <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
          (click)="cancel()" >Abbruch</button>
        </a>
        <span style="flex: 1 1 auto"></span>
        <a>
          <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" matTooltip="Mandantengruppen zuweisen"
          (click)="add()" >Hinzufügen</button>
        </a>

      </div>
    </form>
  </div>
</div>

